import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteKeyLockerMutation } from "modules/KeyLockersDashboard/components/DeleteKeyLockerModal/hooks";

type DeleteKeyLockerModalProps = {
  keyLockerId: number;
  resetDeleteKeyLockerId: () => void;
};

export const DeleteKeyLockerModal = ({ keyLockerId, resetDeleteKeyLockerId }: DeleteKeyLockerModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: deleteKeyLocker, isPending: isDeletingKeyLocker } = useDeleteKeyLockerMutation();

  const handleDeleteKeyLocker = async () => {
    if (!keyLockerId) return;
    await deleteKeyLocker(keyLockerId);
    resetDeleteKeyLockerId();
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={Boolean(keyLockerId)}
      handleCancel={resetDeleteKeyLockerId}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
      handleConfirm={handleDeleteKeyLocker}
      isLoading={isDeletingKeyLocker}
    />
  );
};
